export const COLOR_TEXT_MAIN = '#4d4d4d';
